<template>
  <v-row>
    <v-text-field
      ref="input"
      :label="label"
      :suffix="type !== null ? types.find(v => v.value === type).name : null"
      :placeholder="type !== null ? null : 'Wyłączone'"
      v-model="count"
      :readonly="type === null"
      :rules="[v => type === null || !isNaN(parseInt(v)) || 'Podaj liczbę']"
    />
    <v-btn icon @click="dialog = true" class="my-3">
      <v-icon>
        fa-ellipsis-v
      </v-icon>
    </v-btn>
    <v-dialog max-width="300px" v-model="dialog">
      <v-card>
        <v-card-text>
          <v-autocomplete label="Typ" :items="types" item-text="name" item-value="value" v-model="type" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "PhpDateDiffChooser",
  props: {
    value: {
      required: true
    },
    canBeDisabled: {
      required: false,
      default: true
    },
    label: {
      default: null
    }
  },
  data: () => ({
    dialog: false,
    type: "min",
    count: null
  }),
  watch: {
    dialog(val) {
      if (val === false) {
        this.$refs.input.validate();
        if (this.type === null) {
          this.count = null;
        }
      }
    },
    count(val) {
      if (val === null) {
        this.count = null;
      }
    },
    phpDateDiff(val) {
      this.$emit("update:value", val);
    }
  },
  computed: {
    types() {
      let result = [];
      if (this.canBeDisabled) {
        result.push({ name: "wyłączone", value: null });
      }
      result.push({ name: "minuty", value: "min" });
      result.push({ name: "godziny", value: "hour" });
      result.push({ name: "dni", value: "day" });
      return result;
    },
    phpDateDiff() {
      if (isNaN(parseInt(this.count)) || this.type === null) return null;
      return "+ " + parseInt(this.count) + " " + this.type;
    }
  }
};
</script>

<style scoped></style>
